import $ from 'jquery'
import axios from 'axios'
import _get from 'lodash/get'
import _debounce from 'lodash/debounce'
import { lazyloadNewMedia } from './lazyload'
import { reinit as reinitParallax } from './parallax'

let filterConfig = {}
const $events = $('[data-events]')

export function init() {
  $('[data-event-filters]').each((i, filterGroup) => {
    const $filterGroup = $(filterGroup)
    const $filterReset = $('[data-event-filter-reset]')

    // set config in case arriving from url with filters active
    filterConfig = $filterGroup.data('event-filters') || {}
    const filterConfigKeys = Object.keys(filterConfig)

    $filterGroup
      .find('[data-event-filter]')
      .on('click', function (event) {
        // filter on click
        event.preventDefault()
        const $elem = $(this)
        const $parent = $elem.parent().parent()
        // this is kind of lazy but works for this use case

        $parent.find('[data-event-filter]').each(function () {
          if (this != $elem[0]) $(this).removeClass('active').removeClass('fake-active')
        })

        if ($parent.attr('data-event-filters-not-empty') !== undefined) {
          setTimeout(() => checkNotEmptyState($parent), 10)
        }

        $elem.toggleClass('active')

        filterClick($elem, $filterReset)
        return false
      })
      .each((i, elem) => {
        const $elem = $(elem)
        const data = $elem.data('event-filter') || {}
        let active = false

        // set filter active states if arrived with predetermined config
        Object.keys(data).forEach((setterKey) => {
          const setterValue = data[setterKey]['value']
          if (filterConfigKeys.indexOf(setterKey) >= 0) {
            if (typeof setterValue == 'string') {
              const configValue = filterConfig[setterKey]
              if (configValue instanceof Array) {
                if (configValue.indexOf(setterValue) >= 0) active = true
              } else if (typeof configValue == 'string') {
                if (configValue == setterValue) active = true
              } else {
                console.warn('Filter config has incorrect type', setterKey, typeof configValue)
              }
            } else if (setterValue instanceof Array) {
              console.log('TODO: set filter button state when it applies multiple values')
            }
          }
        })

        if (active) $elem.addClass('active')
      })

    // set reset button state, ignoring past/present finder
    const keyLength = filterConfigKeys.length
    const finders = _get(filterConfig, 'finder', [])
    if (
      !keyLength ||
      (keyLength == 1 &&
        (finders.indexOf('present') >= 0 || finders.indexOf('past') >= 0 || finders.indexOf('lineup') >= 0))
    ) {
      $filterReset.addClass('active')
    } else {
      $filterReset.removeClass('active')
    }

    // reset button click handler
    $filterReset.on('click', function (event) {
      event.preventDefault()
      resetFilter($(this))
    })

    $filterGroup.find('[data-event-search-form]').on('submit', function (event) {
      event.preventDefault()
      return false
    })

    $filterGroup.find('[data-event-filters-not-empty]').each((i, elem) => checkNotEmptyState($(elem)))

    const $searchInput = $filterGroup.find('[data-event-search-input]')
    const $searchInputIcon = $searchInput.next('.input-search-icon')

    const _onSearchChange = function (event) {
      const $input = $(this)
      const value = $input.val()
      $input.data('event-filter', { search: { value, type: 'overwrite' } })
      filterClick($input, $filterReset)
      if (value) $searchInputIcon.addClass('has-value')
      else $searchInputIcon.removeClass('has-value')
    }
    const onSearchChange = _debounce(_onSearchChange, 350)

    $searchInputIcon.on('click', function (event) {
      if ($(this).hasClass('has-value')) {
        $searchInput.val('')
        $searchInput.trigger('input')
      }
    })

    $searchInput.on('input', onSearchChange)
    if ($searchInput.val()) $searchInputIcon.addClass('has-value')
  })
}

// checks any filterConfig value to preserve specific things on reset
// e.g. we have to preserve hidden finder values of 'past' and 'present'
function resetFilterArray(key, value) {
  const returnArray = []
  if (key == 'finder') {
    if (value.indexOf('past') >= 0) returnArray.push('past')
    if (value.indexOf('present') >= 0) returnArray.push('present')
    if (value.indexOf('lineup') >= 0) returnArray.push('lineup')
  }
  return returnArray
}

// called by reset button
function resetFilter($filterReset) {
  // update classes
  $filterReset.addClass('active')
  $('[data-event-filter]').removeClass('active')

  // reset config while preserving past/present finder
  const view = _get(filterConfig, 'view')
  const finders = _get(filterConfig, 'finder', [])
  filterConfig = { finder: resetFilterArray('finder', finders), view }

  // render
  updateUrlParams()
  fetchResults()
}

function checkNotEmptyState($parentElem) {
  const $links = $parentElem.find('[data-event-filter]')
  const $linksNotActive = $parentElem.find('[data-event-filter]:not(.active)')
  if ($links.length === $linksNotActive.length) {
    $links.each((i, link) => $(link).addClass('fake-active'))
  }
}

function filterClick($elem, $filterReset) {
  const filterData = $elem.data('event-filter')
  Object.keys(filterData).forEach((key) => {
    console.log('Filtering on ' + key, filterData[key])
    // create array if nothing there
    if (!filterConfig[key]) filterConfig[key] = []

    const setterValue = filterData[key]['value']
    const setterType = filterData[key]['type'] || 'append'

    // used for adding multiple filters with one button, current isn't used and will probably be broken now that value is no longer a string but an object containing 'value' and 'type'
    if (setterValue instanceof Array) {
      console.log('Setter for ' + key + ' has an array as a value:', setterValue)
      console.warn('This should not happen, send help 911 bigfish.tv')
      const activeValues = setterValue.reduce(
        (count, value) => (filterConfig[key].indexOf(value) >= 0 ? count + 1 : count),
        0
      )
      if (activeValues >= setterValue.length) {
        setterValue.forEach((value) => filterConfig[key].splice(filterConfig[key].indexOf(value), 1))
      } else {
        setterValue.forEach((value) => filterConfig[key].push(value))
      }

      // this is the only one being used in tivoli
    } else if (typeof setterValue == 'string') {
      const index = filterConfig[key].indexOf(setterValue)
      console.log('Setter for ' + key + ' has a string as a value:', setterValue, setterType, index, filterConfig[key])
      // should the filter value replace all others of the same type?
      if (setterType == 'replace') {
        if (index >= 0) {
          // console.log('Clearing all '+key);
          filterConfig[key] = resetFilterArray(key, filterConfig[key])
        } else {
          // console.log('Replacing all '+key+' with '+setterValue);
          filterConfig[key] = [...resetFilterArray(key, filterConfig[key]), setterValue]
        }

        // or should the filter value be appended to others of the same type?
      } else if (setterType == 'append') {
        if (index >= 0) {
          // console.log('Removing '+setterValue+' from '+key);
          filterConfig[key].splice(index, 1)
        } else {
          // console.log('Appending '+setterValue+' to '+key);
          filterConfig[key].push(filterData[key])
        }
      } else if (setterType == 'overwrite') {
        filterConfig[key] = setterValue.split(' ')
      } else {
        console.warn('Unknown setter type: ' + $setterType)
      }

      // god help us all
    } else {
      console.warn('Unsupported typeof setter value', key, setterValue, typeof setterValue)
    }
  })

  const activeFilters = Object.keys(filterConfig).reduce(
    (count, key) =>
      key == 'search' ||
      filterConfig[key].length === 0 ||
      (key == 'finder' &&
        filterConfig[key].length == 1 &&
        ['past', 'present', 'lineup'].indexOf(filterConfig[key][0]) >= 0)
        ? count
        : count + 1,
    0
  )

  if (!activeFilters) $filterReset.addClass('active')
  else $filterReset.removeClass('active')

  updateUrlParams()
  fetchResults()
}

function updateUrlParams() {
  const params = []
  Object.keys(filterConfig).forEach((key) => {
    if (!!filterConfig[key]) {
      if (filterConfig[key] instanceof Array) {
        const values = filterConfig[key].filter(
          (value) => ['past', 'present', 'lineup'].indexOf(value) < 0 && value !== ''
        )
        if (values.length > 0) params.push(key + '=' + values.join('+'))
      } else {
        params.push(key + '=' + filterConfig[key])
      }
    }
  })
  const url = window.location.href.split('?')[0]
  window.history.replaceState({}, $('title').html(), url + (params.length ? '?' + params.join('&') : ''))
}

function fetchResults() {
  axios({
    method: 'post',
    url: '/events/filter',
    data: filterConfig,
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300 && response.data) {
        $events.html(response.data)
        lazyloadNewMedia()
        reinitParallax()
      }
    })
    .catch((error) => {
      setTimeout(() => console.log('Error fetching data', error))
    })
}
